import { render, staticRenderFns } from "./registrationReceive.vue?vue&type=template&id=684705fe&scoped=true"
import script from "./registrationReceive.vue?vue&type=script&lang=js"
export * from "./registrationReceive.vue?vue&type=script&lang=js"
import style0 from "./registrationReceive.vue?vue&type=style&index=0&id=684705fe&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684705fe",
  null
  
)

export default component.exports